import { useTranslation } from 'libs/i18n';
import { AddAndRemoveButtons } from 'modules/onboarding/common/components/AddAndRemoveButtons';

import { useFormContext } from '../../../../forms/companyActivitiesForm';

interface Props {
  index: number;
}

export const Buttons = ({ index }: Props) => {
  const { values, setValues } = useFormContext();

  const { t } = useTranslation();

  const onAdd = () => {
    values.activityTypes.push({ name: '' });
    setValues(values, false);
  };

  const onRemove = (index: number) => {
    values.activityTypes.splice(index, 1);
    setValues(values, false);
  };

  return (
    <AddAndRemoveButtons
      addLabel={t('onboarding.companyActivities.addActivity')}
      counts={values.activityTypes.length}
      index={index}
      maxCount={Infinity}
      removeLabel={t('onboarding.companyActivities.removeActivity')}
      onAdd={onAdd}
      onRemove={onRemove}
    />
  );
};
